import MembresiaSnapshot from "../types/MembresiaSnapshot";

interface Cambio {
  campo: string;
  mensaje: string;
}

export function detectarCambiosMembresia(
  snapshot: MembresiaSnapshot
): Cambio[] {
  const cambios: Cambio[] = [];

  if (!snapshot) {
    return cambios;
  }

  if (snapshot.cotizacionEliminada) {
    cambios.push({
      campo: "eliminada",
      mensaje: "⚠️ La cotización fue eliminada"
    });
  }

  if (snapshot.tipoOperacionSnapshot !== snapshot.tipoOperacion) {
    cambios.push({
      campo: "tipoOperacion",
      mensaje: `Tipo de operación cambió de "${snapshot.tipoOperacionSnapshot}" a "${snapshot.tipoOperacion}"`
    });
  }

  if (snapshot.idClubBaseSnapshot !== snapshot.idClubBase) {
    cambios.push({
      campo: "clubBase",
      mensaje: `Club base cambió de "${snapshot.clubBaseSnapshot}" a "${snapshot.clubBase}"`
    });
  }

  if (snapshot.idPublicoSnapshot !== snapshot.idPublico) {
    cambios.push({
      campo: "publico",
      mensaje: `ID Público cambió de ${snapshot.idPublicoSnapshot} a ${snapshot.idPublico}`
    });
  }

  if (snapshot.idMembresiaSnapshot !== snapshot.idMembresia) {
    cambios.push({
      campo: "membresia",
      mensaje: `Membresía cambió de "${snapshot.membresiaSnapshot}" a "${snapshot.membresia}"`
    });
  }

  if (snapshot.idPromocionSnapshot !== snapshot.idPromocion) {
    cambios.push({
      campo: "promocion",
      mensaje: `Promoción cambió de "${snapshot.promocionSnapshot}" a "${snapshot.promocion}"`
    });
  }

  if (snapshot.idPlanSnapshot !== snapshot.idPlan) {
    cambios.push({
      campo: "plan",
      mensaje: `Plan cambió de "${snapshot.planSnapshot}" a "${snapshot.plan}"`
    });
  }

  if (snapshot.facturaEstatusSnapshot !== snapshot.facturaEstatus) {
    cambios.push({
      campo: "facturaEstatus",
      mensaje: `Estatus factura cambió de "${snapshot.facturaEstatusSnapshot}" a "${snapshot.facturaEstatus}"`
    });
  }

  if (
    snapshot.facturaConNotaCreditoSnapshot !== snapshot.facturaConNotaCredito
  ) {
    const anterior = snapshot.facturaConNotaCreditoSnapshot ? "Sí" : "No";
    const nuevo = snapshot.facturaConNotaCredito ? "Sí" : "No";
    cambios.push({
      campo: "facturaConNotaCredito",
      mensaje: `Factura con nota de crédito cambió de "${anterior}" a "${nuevo}"`
    });
  }

  if (snapshot.facturaValidaSnapshot !== snapshot.facturaValida) {
    const anterior = snapshot.facturaValidaSnapshot ? "Sí" : "No";
    const nuevo = snapshot.facturaValida ? "Sí" : "No";
    cambios.push({
      campo: "facturaValida",
      mensaje: `Factura válida cambió de "${anterior}" a "${nuevo}"`
    });
  }

  if (snapshot.idPersonaSnapshot !== snapshot.idPersona) {
    cambios.push({
      campo: "persona",
      mensaje: `Persona cambió de "${snapshot.personaSnapshot}" a "${snapshot.persona}"`
    });
  }

  if (snapshot.precioVentaSnapshot !== snapshot.precioVenta) {
    cambios.push({
      campo: "precioVenta",
      mensaje: `Precio de venta cambió de $${snapshot.precioVentaSnapshot} a $${snapshot.precioVenta}`
    });
  }

  if (snapshot.idVendedorSnapshot !== snapshot.idVendedor) {
    cambios.push({
      campo: "vendedor",
      mensaje: `Vendedor cambió de "${snapshot.vendedorSnapshot}" a "${snapshot.vendedor}"`
    });
  }

  if (
    snapshot.vendedorNumeroEmpleadoSnapshot !== snapshot.vendedorNumeroEmpleado
  ) {
    cambios.push({
      campo: "vendedorNumeroEmpleado",
      mensaje: `Número de empleado del vendedor cambió de ${snapshot.vendedorNumeroEmpleadoSnapshot} a ${snapshot.vendedorNumeroEmpleado}`
    });
  }

  if (snapshot.vendedorSistemaSnapshot !== snapshot.vendedorSistema) {
    const anterior = snapshot.vendedorSistemaSnapshot ? "Sí" : "No";
    const nuevo = snapshot.vendedorSistema ? "Sí" : "No";
    cambios.push({
      campo: "vendedorSistema",
      mensaje: `Vendedor sistema cambió de "${anterior}" a "${nuevo}"`
    });
  }

  if (snapshot.folioFacturaSnapshot !== snapshot.folioFactura) {
    cambios.push({
      campo: "folioFactura",
      mensaje: `Folio factura cambió de "${snapshot.folioFacturaSnapshot}" a "${snapshot.folioFactura}"`
    });
  }

  if (snapshot.evaluadorModifico) {
    cambios.push({
      campo: "evaluador",
      mensaje: `✓ El evaluador modificó esta membresía${
        snapshot.observaciones ? ": " + snapshot.observaciones : ""
      }`
    });
  }

  return cambios;
}
